module.exports = __webpack_public_path__ + "static/media/success_confirmation.d7f902e7.png";